
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-estate-agency",
      function () {
        return require("private-next-pages/real-estate-agency.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-estate-agency"])
      });
    }
  